import { createFileRoute, useRouter } from '@tanstack/react-router';
import { CreditMemoNewPage } from '@/components/organisms/credit-memos/CreditMemoNewPage';
import { DEFAULT_CREDIT_MEMO_LIST_FILTERS } from '@/components/organisms/credit-memos/credit-memo-list-filters';

type CreditMemoNewSearch = {
  contactId?: string;
  invoiceId?: string;
};

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function readUuidSearch(value: unknown) {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return UUID_PATTERN.test(trimmed) ? trimmed : undefined;
}

export const Route = createFileRoute('/_dashboard/dashboard/credit-memos/new')({
  validateSearch: (search: Record<string, unknown>): CreditMemoNewSearch => ({
    contactId: readUuidSearch(search.contactId),
    invoiceId: readUuidSearch(search.invoiceId),
  }),
  component: CreditMemoNewRoute,
});

function CreditMemoNewRoute() {
  const router = useRouter();
  const search = Route.useSearch();

  function handleBack() {
    void router.navigate({
      to: '/dashboard/credit-memos',
      search: DEFAULT_CREDIT_MEMO_LIST_FILTERS,
    });
  }

  return (
    <CreditMemoNewPage
      contactId={search.contactId}
      invoiceId={search.invoiceId}
      onBack={handleBack}
      onCreated={(result) =>
        void router.navigate({
          to: '/dashboard/credit-memos/$id',
          params: { id: result.id },
          search: DEFAULT_CREDIT_MEMO_LIST_FILTERS,
        })
      }
    />
  );
}
